module.exports = __webpack_public_path__ + "img/mobile_screen.6f95972e.png";